import { render, staticRenderFns } from "./matriz-test.vue?vue&type=template&id=3306ee88"
import script from "./matriz-test.vue?vue&type=script&lang=js"
export * from "./matriz-test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports